import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import schoffaLogo from '../../assets/schoffaLogo.svg';
import tulusLogo from '../../assets/tulus-logo.svg';
import piirlaLogo from '../../assets/piirla-logo.png';
import peikkoLogo from '../../assets/peikko-group-logo.png';
import olefitLogo from '../../assets/olefit-logo.svg';
import eerikkilaLogo from '../../assets/eerikkila-logo.svg';
import coregoLogo from '../../assets/corego-logo.png';
import strongestLogo from '../../assets/strongest-logo-black.svg';
import systamLogo from '../../assets/systam-logo.svg';
import zervantLogo from '../../assets/zervant-logo.svg';
import carbocultureLogo from '../../assets/carboculture-logo.svg';
import fundisLogo from '../../assets/fundis-logo.svg';
import helsinkiLogo from '../../assets/helsinki-logo.png';
import invesdorLogo from '../../assets/invesdor-logo.svg';

import css from './CustomerSignupLogos.css';

const logos = [
  { id: 'systam', imgSrc: systamLogo, className: 'logoSmall' },
  { id: 'corego', imgSrc: coregoLogo, className: 'logoMedium' },
  { id: 'schoffa', imgSrc: schoffaLogo, className: 'logoSmall' },
  { id: 'tulus', imgSrc: tulusLogo, className: 'logoXSmall' },
  { id: 'piirla', imgSrc: piirlaLogo, className: 'logoXSmall' },
  { id: 'peikko', imgSrc: peikkoLogo, className: 'logoMedium' },
  { id: 'olefit', imgSrc: olefitLogo, className: 'logoSmall' },
  { id: 'eerikkila', imgSrc: eerikkilaLogo, className: 'logoMedium' },
  { id: 'strongest', imgSrc: strongestLogo, className: 'logoXSmall' },
  { id: 'zervant', imgSrc: zervantLogo, className: 'logoXSmall' },
  { id: 'carboculture', imgSrc: carbocultureLogo, className: 'logoXSmall' },
  { id: 'fundis', imgSrc: fundisLogo, className: 'logoMedium' },
  { id: 'helsinki', imgSrc: helsinkiLogo, className: 'logoMedium' },
  { id: 'invesdor', imgSrc: invesdorLogo, className: 'logoXXSmall' },
];

const CustomerSignupLogos = () => {
  return (
    <div className={css.root}>
      {/* <span className={css.label}>
        <FormattedMessage id="SectionCustomerLogos.ourCustomers" />
      </span> */}
      <div className={css.logosContainer}>
        {logos.map(logo => (
          <img
            key={logo.id}
            src={logo.imgSrc}
            alt={`${logo.id} Logo`}
            className={css[logo.className]}
            loading="lazy"
          />
        ))}
      </div>
    </div>
  );
};

export default CustomerSignupLogos;
